import { resolveApiUrl } from "../../../../utils/url/urlResolver";
import { registerCallProcessor, scheduleCall } from "~/feature/cart/cart/api/CartService";
import { ApiCallPriority, apiGET } from "~/common/api/apiCallsService";

const apiUrl = resolveApiUrl("/cart/deleteCart");

export function send(): Promise<unknown> {
  return scheduleCall("deleteCart", {});
}

registerCallProcessor({
  type: "deleteCart",
  execute: async () => {
    const response = await apiGET(
      apiUrl,
      {
        credentials: "same-origin", // include, omit
        mode: "cors", // no-cors, same-origin
        referrer: "no-referrer", // client
      },
      { priority: ApiCallPriority.HIGH, skipParallelLimit: true },
    );

    if (!response.ok) {
      throw new Error("Error when clearing cart");
    }

    if (window.SCHA.clearMinicart) {
      window.SCHA.clearMinicart();
    }
    return response;
  },
  canBeExecuted: (ongoingCalls) => {
    const areCallsOngoing = ongoingCalls.length > 0;
    return !areCallsOngoing;
  },
});
